(function () {
  if (window.__kspOrderInquiryBound) return;
  window.__kspOrderInquiryBound = true;

  const modalSelector = 'modal-dialog.ksp-order-inquiry-modal';
  const openButtonSelector = '#ksp-order-inquiry-open, .ksp-order-inquiry__open';

  function formatMoney(cents) {
    return new Intl.NumberFormat('de-DE', {
      style: 'currency',
      currency: 'EUR',
    }).format(cents / 100);
  }

  function buildCartSummary(cart) {
    const lines = ['BESTELLANFRAGE – Warenkorb', ''];

    cart.items.forEach((item) => {
      const sku = item.sku || '–';
      const variant = item.variant_title && item.variant_title !== 'Default Title' ? ` (${item.variant_title})` : '';
      lines.push(
        `${item.quantity}x ${item.product_title}${variant}`,
        `   SKU: ${sku} | Einzelpreis (netto): ${formatMoney(item.final_price)} | Zeile (netto): ${formatMoney(item.final_line_price)}`
      );
      lines.push('');
    });

    lines.push(`Zwischensumme (netto): ${formatMoney(cart.items_subtotal_price)}`);
    lines.push(`Gesamt (netto, zzgl. MwSt.): ${formatMoney(cart.items_subtotal_price)}`);
    lines.push(`Warenkorb-URL: ${window.location.origin}/cart`);

    return lines.join('\n');
  }

  function buildCartPreviewHtml(cart) {
    if (!cart.items.length) {
      return '<p class="ksp-order-inquiry__cart-empty">Der Warenkorb ist leer.</p>';
    }

    const items = cart.items
      .map((item) => {
        const variant =
          item.variant_title && item.variant_title !== 'Default Title'
            ? `<span class="ksp-order-inquiry__cart-variant">${item.variant_title}</span>`
            : '';
        return `
          <li class="ksp-order-inquiry__cart-item">
            <span class="ksp-order-inquiry__cart-qty">${item.quantity}×</span>
            <span class="ksp-order-inquiry__cart-name">${item.product_title}${variant}</span>
            <span class="ksp-order-inquiry__cart-line">${formatMoney(item.final_line_price)}</span>
          </li>
        `;
      })
      .join('');

    return `
      <ul class="ksp-order-inquiry__cart-list">${items}</ul>
      <p class="ksp-order-inquiry__cart-total">
        <span>Zwischensumme (netto)</span>
        <strong>${formatMoney(cart.items_subtotal_price)}</strong>
      </p>
    `;
  }

  function getModal() {
    const modals = Array.from(document.querySelectorAll(modalSelector));
    if (!modals.length) return null;

    // Nach Footer-Refresh können Duplikate auf body liegen – nur eines behalten
    const keep = modals[modals.length - 1];
    modals.forEach((modal) => {
      if (modal !== keep) modal.remove();
    });
    return keep;
  }

  async function populateCartData(modal) {
    const preview = modal.querySelector('#KspInquiryCartPreview');
    const hiddenField = modal.querySelector('#KspInquiryCartData');
    if (!preview || !hiddenField) return;

    try {
      const response = await fetch(`${window.routes?.cart_url || '/cart'}.js`);
      const cart = await response.json();
      const summary = buildCartSummary(cart);

      hiddenField.value = summary;
      preview.innerHTML = buildCartPreviewHtml(cart);
    } catch (error) {
      preview.innerHTML = '<p class="ksp-order-inquiry__cart-empty">Warenkorb konnte nicht geladen werden.</p>';
    }
  }

  function openModal(opener) {
    const modal = getModal();
    if (!modal || typeof modal.show !== 'function') return;

    populateCartData(modal).finally(() => {
      if (typeof modal.show === 'function') {
        modal.show(opener || modal.querySelector('[role="dialog"]'));
      }
    });
  }

  document.addEventListener('click', (event) => {
    const openButton = event.target.closest(openButtonSelector);
    if (!openButton || openButton.disabled) return;
    event.preventDefault();
    openModal(openButton);
  });

  function markInvalidFields(form) {
    form.querySelectorAll('[required]').forEach((field) => {
      const empty = !String(field.value || '').trim();
      const invalidEmail =
        field.type === 'email' && field.value && !field.checkValidity();
      field.classList.toggle('is-invalid', empty || invalidEmail);
      field.setAttribute('aria-invalid', empty || invalidEmail ? 'true' : 'false');
    });
  }

  document.addEventListener(
    'submit',
    (event) => {
      const form = event.target.closest('#KspOrderInquiryForm');
      if (!form) return;

      // Leere Pflichtfelder / ungültige E-Mail → nicht senden
      const requiredFields = Array.from(form.querySelectorAll('[required]'));
      const firstInvalid = requiredFields.find((field) => {
        const value = String(field.value || '').trim();
        if (!value) return true;
        if (field.type === 'email') return !field.checkValidity();
        return false;
      });

      if (firstInvalid) {
        event.preventDefault();
        event.stopImmediatePropagation();
        markInvalidFields(form);
        firstInvalid.focus();
        if (typeof form.reportValidity === 'function') {
          form.reportValidity();
        }
        return;
      }

      markInvalidFields(form);

      const modal = form.closest(modalSelector) || getModal();
      if (modal) {
        // Warenkorb-Daten vor dem Absenden aktualisieren (ohne Submit zu blockieren)
        populateCartData(modal);
      }
    },
    true
  );

  document.addEventListener('input', (event) => {
    const field = event.target.closest('#KspOrderInquiryForm [required]');
    if (!field) return;
    if (String(field.value || '').trim() && field.checkValidity()) {
      field.classList.remove('is-invalid');
      field.setAttribute('aria-invalid', 'false');
    }
  });

  function maybeReopen() {
    if (!document.querySelector('[data-ksp-inquiry-reopen]')) return;
    openModal(document.querySelector(openButtonSelector));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', maybeReopen);
  } else {
    maybeReopen();
  }
})();
